import { render, staticRenderFns } from "./LoadingTextWave.vue?vue&type=template&id=63f6835a&scoped=true&"
import script from "./LoadingTextWave.vue?vue&type=script&lang=ts&"
export * from "./LoadingTextWave.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingTextWave.vue?vue&type=style&index=0&id=63f6835a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6835a",
  null
  
)

export default component.exports